<div class="row justify-content-between">
  <div class="col-xl-6 col-lg-6 col-12 mb-xl-0 mb-lg-0 mb-5 p-0 position-relative">
      <app-produto-menu #elementoMenu class="col position-absolute"></app-produto-menu>
  </div>
  <div class="col-xl-6 col-lg-6 col-12 mt-xl-0 mt-lg-0 mt-5">
      <app-buscar></app-buscar>
  </div>
</div>
